// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__BuF87"};